import "ngstorage";

import {REFERENCE_SCREENS} from "../../variables";

class QuestionsixController {
  constructor($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
    this.name = "questionsix";
    //this.walkthroughState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;
    this.referenceScreens = REFERENCE_SCREENS;
  }

  $onInit() {}

  goNext() {
    this.$timeout(() => {
      this.$rootScope.$emit("SendToNextReferenceScreen", {
        referenceScreen: this.referenceScreens.POSTCONFIRMATION,
      });
    });
  }

  saveAnswer() {

    let data = {};

    this.setLoader();
    data.questionId = 5;
    data.answer = this.answer;
    data.userReferenceId = this.event.rid;
    data.status = "COMPLETED";

    this.$security.saveReferenceQuestion(data).then(
      (response) => {
        this.unSetLoader();
        this.goNext();
      },
      (error) => {
        this.unSetLoader();
        alert("error saving answer");
      }
    );
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

}

QuestionsixController.$inject = [
  "$localStorage",
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
];

export default QuestionsixController;



// WEBPACK FOOTER //
// ./client/app/scenes/references/scenes/questionsix/questionsix.controller.js